import { useContext } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
export function useShowMobileAd(deviation) {
    var deviationType = getDeviationType(deviation);
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var isMobile = useContext(MobileContext);
    var adsNitro = useFlag('ads_nitro');
    var adsEnabledDeviation = [DeviationTypes.IMAGE].includes(deviationType);
    return {
        showVideoAd: isMobile && adsEnabled && adsNitro && adsEnabledDeviation,
        showAdhesionAd: isMobile && adsEnabled && adsNitro,
    };
}
//# sourceMappingURL=useShowMobileAd.js.map